/** Dock panel definitions — the workspace furniture. */

import { definePanel, type PanelDefinition } from "@tredespace/ui/dockable";
import { PANEL_IDS } from "./panelIds.ts";
import { BaseJackPanel } from "./panels/BaseJackPanel.tsx";
import { BomPanel } from "./panels/BomPanel.tsx";
import { GeneratorPanel } from "./panels/GeneratorPanel.tsx";
import { PlanesPanel } from "./panels/PlanesPanel.tsx";
import { ReferencePanel } from "./panels/ReferencePanel.tsx";
import { RibbonBar } from "./RibbonBar.tsx";
import { ViewportPanel } from "./ViewportPanel.tsx";

export const scaffolderPanels: PanelDefinition[] = [
  definePanel({
    id: PANEL_IDS.ribbon,
    title: "Toolbar",
    component: RibbonBar,
    closable: false,
    floatable: false,
    dockableIn: "top",
  }),
  definePanel({
    id: PANEL_IDS.viewport,
    title: "3D view",
    component: ViewportPanel,
    minWidth: 320,
    minHeight: 240,
    closable: false,
  }),
  definePanel({ id: PANEL_IDS.generator, title: "Generator", component: GeneratorPanel, minWidth: 210 }),
  definePanel({
    id: PANEL_IDS.reference,
    title: "Reference model",
    component: ReferencePanel,
    minWidth: 210,
  }),
  definePanel({ id: PANEL_IDS.planes, title: "Planes", component: PlanesPanel, minWidth: 210 }),
  definePanel({ id: PANEL_IDS.bom, title: "Component list", component: BomPanel, minWidth: 250 }),
  definePanel({ id: PANEL_IDS.jacks, title: "Base jacks", component: BaseJackPanel, minWidth: 210 }),
];

export { PANEL_IDS };
